<template>
  <LoginVue />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import LoginVue  from './components/LoginVue.vue';

export default defineComponent({
  name: 'App',
  components: {
    LoginVue
  }
});
</script>

<style lang="scss">
</style>
